// extracted by mini-css-extract-plugin
export default {"header":"xXISTIV3mX7hteCclIdi"};